<template>
  <div id="app">
    <v-app :ripple="false" :class="this.$route.name">
      <vue-headful :title="pageTitle" />
      <Header
        v-if="!$route.meta.hideHeader"
        app
        :page-title="pageTitle"
        v-on:changeNavicationDrawer="onChangeNavicationDrawer"
      />
      <NavigationDrawer app />
      <v-content app class="content-wrapper">
        <v-container :fluid="fluid" class="pa-0 ml-0">
          <router-view app />
        </v-container>
      </v-content>

      <v-snackbar
        v-if="$store.getters.snackbar.visible"
        auto-height
        :color="$store.getters.snackbar.color"
        :timeout="$store.getters.snackbar.timeout"
        :top="$store.getters.snackbar.top"
        :bottom="$store.getters.snackbar.bottom"
        v-model="snackbar"
      >
        <v-icon v-if="$store.getters.snackbar.color == 'error'" class="mr-2" color="white"
          >info</v-icon
        >
        {{ $store.getters.snackbar.title }}
        <v-spacer></v-spacer>
      </v-snackbar>
      <TokenExpireModal v-if="showTokenExpireModal" />
      <ScrollTop v-if="showScrollTop" />
    </v-app>
  </div>
</template>

<script>
import i18next from '@/plugins/i18next'
import NS_vi from '@/partner/locales/vi/partner.json'
import NS_en from '@/partner/locales/en/partner.json'

i18next.addResourceBundle('vi', 'common', NS_vi, true)
i18next.addResourceBundle('en', 'common', NS_en, true)

import Header from './components/Header'
import NavigationDrawer from './components/Sidebar/NavigationDrawer.vue'
import TokenExpireModal from '@/components/TokenExpireModal'
import ScrollTop from '@/components/ScrollTop'

// import fingerprint2 from '@/mixins/fingerprint2'

import OfflineHandler from '@/plugins/offline-handler'

import { initUserToken } from '@/plugins/util'
const SHOW_SCROLL_TO_TOP = ['records', 'notification', 'user_balance', 'history']

export default {
  name: 'App',
  components: {
    Header,
    NavigationDrawer,
    TokenExpireModal,
    ScrollTop
  },
  data() {
    return {
      drawer: null,
      snackbar: false
    }
  },
  computed: {
    fluid() {
      return this.$route.meta.containerFluid
    },
    snackBarVisible() {
      return this.$store.getters.snackbar.visible
    },
    showTokenExpireModal() {
      return this.$store.getters.showTokenExpireModal
    },
    showScrollTop() {
      return SHOW_SCROLL_TO_TOP.indexOf(this.$route.name) > -1
    },
    pageTitle() {
      let result, key
      if (this.$route && this.$route.name) {
        const name = this.$route.name.replace(/-/g, '_')
        key = `page.${name}`
        result = this.$t(key)
      }

      switch (this.$route.name) {
        case 'record_detail':
          result = this.$t('page.record_detail')
          break
        case 'embedded':
        case 'embedded_frontend-reactjs': {
          const eId = (this.$route.query && this.$route.query.p) || ''
          const kaProfile = this.$store.getters.kaProfile
          result = ''
          if (eId && kaProfile) {
            if (kaProfile.features_v2) {
              const found = kaProfile.features_v2.find((f) => f.id === eId)
              if (found) {
                result =
                  this.$store.getters.locale === 'vi'
                    ? found.name_vn || found.name
                    : found.name_en || found.name
              }
            } else if (kaProfile.features) {
              const found = kaProfile.features.find((f) => f.id === eId)
              if (found) {
                result = found.name
              }
            }
          }
          break
        }
      }

      return result
    }
  },
  methods: {
    onChangeNavicationDrawer(data) {
      this.drawer = data
      this.$forceUpdate()
    }
  },
  created() {
    OfflineHandler(this)
    const store = this.$store
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') {
        store.dispatch('setIsfocusTab', false)
      } else {
        store.dispatch('setIsfocusTab', true)
      }
    })
    initUserToken(this)
    if (this.$store.getters.token) {
      this.$_globalMixin_updateUserProfile()
    }
  },
  beforeMount() {
    if (this.isMobile) {
      this.$store.dispatch('setNavigationMini', false)
      this.$store.dispatch('setNavigationDrawer', false)
    }
  },
  mounted() {
    // let showOfflineWaring = false;
    // let updateIndicator = () => {
    //   const isOnline = navigator.onLine ? true : false;
    //   if (!isOnline) {
    //     this.$store.dispatch("setNetworkConnection", false);
    //     if (!showOfflineWaring) {
    //       this.$store.dispatch("setSnackbar", {
    //         visible: true,
    //         color: "error",
    //         timeout: 0,
    //         title: this.$t("internet_disconnect")
    //       });
    //       showOfflineWaring = true;
    //     }
    //   } else {
    //     this.$store.dispatch("setNetworkConnection", true);
    //     if (showOfflineWaring) {
    //       this.$store.dispatch("setSnackbar", {
    //         visible: false
    //       });
    //       showOfflineWaring = false;
    //     }
    //   }
    // };

    // window.addEventListener("online", updateIndicator);
    // window.addEventListener("offline", updateIndicator);
    // updateIndicator();

    this.$analyticTracking.logEvent(
      this.$trackingEvents.ACTIONS.NON_INTERACTION,
      this.$trackingEvents.EVENTS.PARTNER_LOAD_MAIN_APP,
      {}
    )
  },
  watch: {
    snackBarVisible(val) {
      if (val) {
        this.snackbar = val
      }
    },
    snackbar(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$store.dispatch('setSnackbar', { visible: false })
      }
    },
    isMobile(val) {
      if (val) {
        this.$store.dispatch('setNavigationMini', false)
        this.$store.dispatch('setNavigationDrawer', null)
      }
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700');

body {
  margin: 0;
  font-family: 'SVN Gilroy', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', 'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  // Prevent scroll when show dialog

  &.body--prevent-scroll {
    overflow: hidden;
    position: fixed;
    width: 100%;
  }
}

@media screen and (min-width: 768px) {
  body {
    &.body--prevent-scroll {
      position: absolute;
    }
  }
}
// End prevent scroll

.is-clipped {
  overflow: hidden !important;
}

.outupdate-browser-suggest {
  .v-snack__wrapper {
    max-width: 100%;
    width: 100%;
    border-radius: 0;
  }
}

#app {
  font-family: 'SVN Gilroy', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', 'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  .application.theme--light {
    background: #f2f2f2;
  }

  .v-overlay::before {
    background-color: rgba(23, 43, 77, 0.69);
  }

  label {
    &.caption {
      color: #888;
      font-weight: 500;
    }
  }

  .page-wrapper {
    background: #fff;
    margin-top: 14px;
    margin-left: 24px;
  }

  .new_order {
    input {
      font-size: 14px;
    }
  }

  .v-input__slot::before {
    border-color: rgba(0, 0, 0, 0.1);
  }

  .v-messages {
    min-height: 0;
  }

  .input-group.input-group--solo label {
    top: 4px;
    font-size: 14px;
  }

  .input-group.input-group--solo {
    min-height: initial;
  }

  .input-group.input-group--solo .input-group__input {
    padding: 6px 14px;
  }

  .input-group--text-field {
    input {
      height: 24px;
      font-size: 14px;
    }
  }

  .v-overlay--active::before {
    opacity: 0.76;
  }

  .position-relative {
    position: relative;
  }

  .text-transform-initial {
    text-transform: initial;
  }

  .text-transform-none {
    text-transform: initial;
  }

  .text-decoration-none {
    text-decoration: none;
  }

  .pull-right {
    float: right;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .vertial-align-middle {
    vertical-align: middle;
  }

  .lowercase--text {
    text-transform: lowercase;
  }

  .v-menu__content.v-autocomplete__content {
    z-index: 400 !important;
    max-width: 500px;
  }

  .relative {
    position: relative;
  }

  .ah--form--custom {
    .form--input {
      position: relative;

      .input--icon {
        position: absolute;
        top: 45%;
      }

      input {
        padding-left: 25px;
      }
    }

    .form--input--innerprefix {
      .v-icon {
        font-size: 18px;
        color: #999 !important;

        &.success--text {
          color: $success !important;
        }
      }

      .v-label {
        // left: -25px !important;
        left: -32px !important;
      }
    }

    .v-label {
      color: #808080 !important;
      font-weight: 500;
    }

    input {
      color: #1a1a1a;
    }
  }

  .uppercase {
    text-transform: uppercase;
  }
}

.content--wrap {
  background-color: #fff;
}

.scroll-view {
  /* -- Attention: This line is extremely important in chrome 55+! -- */
  touch-action: none;

  /* -- Attention-- */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: 1;
}

.iScrollHorizontalScrollbar {
  position: absolute;
  z-index: 9999;
  height: 16px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  overflow: hidden;
}

.iScrollHorizontalScrollbar.iScrollBothScrollbars {
  right: 18px;
}

.iScrollVerticalScrollbar {
  position: absolute;
  z-index: 9999;
  width: 8px;
  bottom: 2px;
  top: 2px;
  right: 2px;
  overflow: hidden;
}

.iScrollVerticalScrollbar.iScrollBothScrollbars {
  bottom: 18px;
}

.iScrollIndicator {
  position: absolute;
  background: rgba(0, 0, 0, 0.23);
  border-width: 1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.13); // red;// rgb(255, 255, 255);
  border-radius: 8px;
}

.iScrollHorizontalScrollbar .iScrollIndicator {
  height: 100%;
  background: rgba(0, 0, 0, 0.33);
}

.iScrollVerticalScrollbar .iScrollIndicator {
  width: 100%;
  background: rgba(0, 0, 0, 0.33);
}

.max-width-wrapper {
  max-width: 867px;
}

.max-width-container-lg {
  margin: auto;
}

.clearfix::after {
  content: '';
  clear: both;
  display: table;
}

.btn-auto-width {
  min-width: 0 !important;
}

.fileinput-button {
  position: relative;
  padding: 0;

  .v-btn__content {
    height: 36px;
    width: 100%;
    padding: 0 8px;
  }

  input {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    opacity: 0;
    font-size: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 1;
  }
}

.v-tooltip__custom-content {
  background: #1a1a1a;
  opacity: 0.7;
  border-radius: 8px;
  max-width: 300px;
  word-wrap: break-word;
}

@media screen and (min-width: 1440px) {
  .max-width-container-lg {
    max-width: 1440px;
  }
}
@media screen and (max-width: 480px) {
  #app {
    .mobile-scrolling-div {
      overflow: scroll;
      height: 100%;
      width: 100%;
      -webkit-overflow-scrolling: touch;
    }

    // .scroll-view {
    // 	touch-action: initial;
    // 	// /* -- Attention-- */
    // 	position: initial;
    // 	// top: 0;
    // 	// bottom: 0;
    // 	// left: 0;
    // 	// right: 0;
    // 	overflow: scroll;
    // 	// z-index: 1;
    // }
  }
}
@media only screen and (max-width: 719px) {
  #app {
    .page-wrapper {
      margin: 1rem;
    }

    .new_order {
      input {
        font-size: 13px;
      }
    }
  }
}
</style>
